import type { QuickFillItem } from '../../../shared/types';
import { resolveQuickFillAutoFillSourceName } from '../../../shared/lib/utils/autoFillService';
import type { BulkUpdateResult } from '../../../shared/services/quickFillRevitService';

export const AUTO_FILL_LOG_SOURCE = 'quickFillAutoFill';
export const AUTO_FILL_LOG_SAMPLE_SIZE = 8;

export const summarizeAutoFillRow = (item: QuickFillItem | undefined, rowIndex: number) => {
  const record = item as Record<string, unknown> | undefined;
  return {
    rowIndex,
    source: resolveQuickFillAutoFillSourceName(record),
    name: typeof record?.Name === 'string' ? record.Name : '',
    rowMode: record?.__rowMode,
    snapshotShape: record?.__quickFillSnapshotShape,
    familyName: record?.__familyName,
    typeName: record?.__typeName,
    familyTypeKey: record?.__familyTypeKey,
    elementId: record?.__elementId,
  };
};

export const stringifyAutoFillLog = (event: string, payload: Record<string, unknown>): string => {
  try {
    return `${event} ${JSON.stringify(payload)}`;
  } catch {
    return `${event} <unserializable>`;
  }
};

export interface QuickFillSubmitOutcome {
  result: BulkUpdateResult | null;
  warning?: string;
}

export interface QuickFillTableCellStageUpdate {
  rowIndex: number;
  field: keyof QuickFillItem;
  value: string;
}

export interface QuickFillTableCellStageResult {
  updatedCells: number;
  touchedRowIndices: number[];
}
